var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppFileUpload',{attrs:{"uploadedFile":_vm.workflowAppearanceSettings.background_file,"uploadFunc":_vm.uploadFunc,"placeholder":"Select your background image","accept":"image/png, image/jpg"},on:{"onFileUploaded":_vm.updateWorkflowVersionSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }